import { homeApi } from "@/api/template";
const state = {
  ids: {
    cart: "968735360159096833"
  },
  cartData: []
};
const getters = {
  cartData: state => state.cartData
};
const actions = {
  getRecommendCart({ commit, state }) {
    homeApi.appHomePage(state.ids.cart).then(res => {
      return new Promise((resolve, reject) => {
        resolve();
        commit("getCartData", res.data);
      });
    });
  }
};

const mutations = {
  getCartData(state, data) {
    state.cartData = data;
  }
};
export default {
  state,
  mutations,
  actions,
  getters
};
